<template>
  <f7-login-screen @loginscreen:closed="onClose" theme-dark>
    <f7-page login-screen>
      <f7-login-screen-title>
        <img src="~@/assets/img/Aio-Light-Transparent-200px.png"
             srcset="~@/assets/img/Aio-Light-Transparent-200px.png 1x, ~@/assets/img/Aio-Light-Transparent-400px.png 2x, ~@/assets/img/Aio-Light-Transparent-600px.png 3x"
             alt="aio* logo"
        >
        <p>Expenses simplified.</p>
      </f7-login-screen-title>
      <f7-list form v-if="state === authState.DEFAULT">
        <f7-list-input :label="$t('label.email')"
                       name="email"
                       type="email"
                       :value="email"
                       @input="email = $event.target.value"
                       :placeholder="$t('placeholder.email')"
        />
        <f7-list-input :label="$t('label.password')"
                       name="password"
                       type="password"
                       :placeholder="$t('placeholder.password')"
                       :value="password"
                       @input="password = $event.target.value"
        />
        <f7-list-item>
          <f7-link @click="onForgotPassword">{{$t('action.forgotPassword')}}</f7-link>
        </f7-list-item>
        <f7-block>
          <button type="submit" @click.prevent="submit" class="button button-large button-fill">
            {{$t('action.signIn')}}
          </button>
          <f7-block-footer>
            <p>{{$t('title.or')}}
              <f7-link @click="onRegister">{{$t('action.register')}}</f7-link>
            </p>
          </f7-block-footer>
        </f7-block>
        <div class="pp">
          <f7-link external href="https://getaio.co.uk/privacy/" target="_blank">
            Privacy Policy
          </f7-link>
        </div>
      </f7-list>
      <f7-list form v-if="state === authState.CHALLENGE">
        <f7-list-input :label="$t('label.otpCode')"
                       name="otp"
                       :value="otp"
                       @input="otp = $event.target.value"
                       :placeholder="$t('placeholder.otpCode')"
                       type="text"
        />
        <f7-block>
          <button type="submit" @click.prevent="submitOTP" class="button button-large button-fill">
            {{$t('action.signIn')}}
          </button>
          <f7-block-footer>
            <p>{{$t('text.didntReceiveCode')}}
              <f7-link @click="onResend">{{$t('action.resend')}}</f7-link>
              <transition name="fade">
                &nbsp;<f7-icon ios="f7:checkmark" md="material:check" size="20px" v-show="resent" color="gray"/>
              </transition>
            </p>
          </f7-block-footer>
        </f7-block>
      </f7-list>
    </f7-page>
  </f7-login-screen>
</template>

<script>
  import api from 'aio-api'
  import cordovaHelpers from '@/utils/cordova-helpers'
  import helpers from '@/utils/helpers'

  const authState = {
    DEFAULT: 'default',
    CHALLENGE: 'challenge',
  }

  export default {
    name: 'login-screen',
    data () {
      return {
        authState,
        state: authState.DEFAULT,
        email: '',
        password: '',
        otp: '',
        resent: false
      }
    },
    methods: {
      async login (email, password) {
        let response
        try {
          response = await api.session.create.byPassword(email, password)
        } catch (err) {
          if (err.response && err.response.status == 400) {
            this.$f7.dialog.alert('Email or Password incorrect', 'Login Failed')
          } else {
            this.$f7.dialog.alert('Error sending login request', 'Please check your network connection')
          }
          return
        }

        if (!response) {
          // OTP time
          this.state = authState.CHALLENGE
        } else {
          // success
          this.registerDevice()
          this.$bus.emit('init-app')
          this.$f7.loginScreen.close()
        }
      },
      async deviceLogin(token) {
        try {
          await api.session.create.byDeviceToken(token)
        } catch (err) {
          console.error(err)
          this.$f7.dialog.alert('Invalid device token', 'Login failed, please log in using username and password')
          return
        }
        this.$bus.emit('init-app')
        this.$f7.loginScreen.close()
      },
      async loginOTP(otp, email, password) {
        try {
          await api.session.create.byOTP(email, password, otp)
        } catch (err) {
          this.$f7.dialog.alert('Incorrect Code', 'Login Failed')
          return
        }
        await this.registerDevice()
        this.$bus.emit('init-app')
        this.$f7.loginScreen.close()
        this.$f7router.navigate(this.links.root)
      },
      onClose () {
        this.$f7router.navigate(this.links.root)
      },
      onForgotPassword () {
        window.open('https://signup.getaio.co.uk/forgot-password.html', '_blank', 'location=no')
      },
      onRegister () {
        window.open('https://signup.getaio.co.uk/company.html', '_blank', 'location=no')
      },
      async onResend () {
        this.resent = false
        try {
          await api.session.otp.resend(this.email, this.password)
          this.resent = true
        } catch (err) {
          this.$f7.dialog.alert('Error resending code')
        }
      },
      submit () {
        this.login(this.email, this.password)
      },
      submitOTP () {
        this.loginOTP(this.otp, this.email, this.password)
      },
    },
    mixins: [helpers, cordovaHelpers],
    mounted () {
      this.$bus.on('deviceLogin', this.deviceLogin)
      this.initBiometricAuth()
    },
  }
</script>

<style lang="scss" scoped>
  @import '@/sass/variables.scss';

  .ios .login-screen.theme-dark .page, .md .login-screen.theme-dark .page {
    background: $bg-grey;
    background-image: url("~@/assets/img/bg-pattern.svg");
  }

  .login-screen-content .list {
    background: rgba(62, 62, 61, .8);
    padding: 30px 0 1px 0;

    --f7-list-item-border-color: rgba(255, 255, 255, 0.08);
    --f7-list-border-color: rgba(255, 255, 255, 0.08);
  }

  .login-screen-title {
    img {
      margin-left: 32px;
    }

    p {
      font-size: 14px;
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .4s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .pp {
    a {
      font-size: x-small;
      filter: saturate(20%) brightness(0.8);
      padding-left: .5em;
    }
  }
</style>
